import { render, staticRenderFns } from "./event-full.vue?vue&type=template&id=91ee91aa&scoped=true"
import script from "./event-full.vue?vue&type=script&lang=js"
export * from "./event-full.vue?vue&type=script&lang=js"
import style0 from "./event-full.vue?vue&type=style&index=0&id=91ee91aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ee91aa",
  null
  
)

export default component.exports